import { Reveal, SectionHead } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/content";

const Faq = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="relative border-t border-[#27272A] bg-[#0a0a0c] py-24 sm:py-32"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHead
            eyebrow="Questions"
            title="Asked by every man before his first cycle."
            testId="faq-heading"
          />
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-zinc-500">
              No sales pitch here. The protocols are published in full on the
              Method page — the only thing membership costs is consistency.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.1} className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                className="border-[#27272A]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left font-syne text-base font-bold tracking-tight text-zinc-200 hover:text-[#CC0A14] hover:no-underline sm:text-lg [&[data-state=open]]:text-[#CC0A14]"
                >
                  <span className="mr-4 font-jb text-[11px] text-zinc-600">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pl-9 text-sm leading-relaxed text-zinc-400 sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Faq;
